<!--Copyright 2024 Sadiant Inc. All Rights Reserved. This software is subject to a license agreement. Unauthorized or unlicensed use is prohibited.-->
<app-menu></app-menu>
<app-breadcrumb></app-breadcrumb>
<router-outlet></router-outlet>
<app-social-share></app-social-share>
<app-footer></app-footer>
